import Home from './Home';
import Login from './Login';
import Article from './Article';
import Dashboard from './Dashboard';
import Category from './Category';
import Page from './Page';
import Announcement from './Announcement';

export default {
  Home,
  Login,
  Article,
  Dashboard,
  Category,
  Page,
  Announcement,
};



// WEBPACK FOOTER //
// ./src/screens/index.js